module.exports = __webpack_public_path__ + "static/media/user-protection-success.f3139c2a.svg";